import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '@app/features/auth/services/auth.service';
import { ToastService } from '../components/toast/services/toast.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private toastService: ToastService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
     
            const error = err.statusText;
            if (err.status == 401) {
                //Logout if 401 Unauthorized
              
                this.authService.logout();
            }
            if (err.status == 403) {
                //Logout if 401 Unauthorized
                this.authService.forbidden();
                const that = this;
                setTimeout(function(){
                    that.toastService.open('toast-error');
                }, 500);
                
            }

            return throwError(() => err);
        }))
    }
}